import * as angular from "angular";
import type { JsonSchemaDefinition } from "../../../../../../../extensions/json-schema/runtime";
import type { TimeZoneAppState } from "../../../../../../../extensions/json-schema/components/time-zone-context";
import {
	buildEntitySchemaDisplay,
	EntitySchemaColumn,
	EntitySchemaDisplay,
	formatEntitySchemaTableCell
} from "../entitySchemaDisplayModel";
import template from "./entity-schema-values.html";
import "./entity-schema-values.less";

export interface EntitySchemaValuesController {
	schema: JsonSchemaDefinition;

	model: unknown;

	path?: string;
}

// AngularJS owns the merged binding properties.
// eslint-disable-next-line no-redeclare
export class EntitySchemaValuesController implements angular.IController {
	public static $inject = ["appState"];

	public display!: EntitySchemaDisplay;

	public constructor(private readonly appState: TimeZoneAppState) {}

	public $onChanges(): void {
		this.display = buildEntitySchemaDisplay(this.schema, this.model, this.path, this.appState.forms?.selected);
	}

	public formatTableCell(row: unknown, column: EntitySchemaColumn): string | number {
		return formatEntitySchemaTableCell(row, column, this.appState.forms?.selected);
	}
}

export default angular.module("vesl.components.entity-schema-values", [])
	.component("entitySchemaValues", {
		controller: EntitySchemaValuesController,
		template,
		bindings: {
			schema: "<",
			path: "<?",
			model: "<"
		}
	})
	.name;
